import { OriginMap } from './global';
import version from './version';

/**
 * @ignore
 */
export const DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS = 30;
/**
 * @ignore
 */
export const POPUP_CHECK_INTERVAL_IN_MS = 1000;

/**
 * @ignore
 */
export const DEFAULT_POPUP_TIMEOUT_IN_MS = 900000;

/**
 * @ignore
 */
export const DEFAULT_POPUP_WIDTH_IN_PIXELS = 770;

/**
 * @ignore
 */
export const DEFAULT_POPUP_HEIGHT_IN_PIXELS = 770;

/**
 * @ignore
 */
export const DEFAULT_SILENT_TOKEN_RETRY_COUNT = 3;

/**
 * @ignore
 */
export const CLEANUP_IFRAME_TIMEOUT_IN_SECONDS = 2;

/**
 * @ignore
 */
export const DEFAULT_FETCH_TIMEOUT_MS = 10000;

export const CACHE_LOCATION_MEMORY = 'memory';
export const CACHE_LOCATION_SESSION_STORAGE = 'sessionstorage';

export const PKCE_CODE_VERIFIER = 'pkce_code_verifier';
export const POPUP_PKCE_CODE_VERIFIER = 'popup_pkce_code_verifier';

/**
 * @ignore
 */
export const IS_AUTHENTICATED_CACHED_TIME_MS = 5;

/**
 * @ignore
 */
export const MISSING_REFRESH_TOKEN_ERROR_MESSAGE =
  'The web worker is missing the refresh token';

/**
 * @ignore
 */
export const INVALID_REFRESH_TOKEN_ERROR_MESSAGE = 'refresh token is invalid';

/**
 * @ignore
 */
export const DEFAULT_SCOPE = 'data:read openid';

/**
 * @ignore
 */
export const DEFAULT_ENV = 'prod';

/**
 * A list of errors that can be issued by the authorization server which the
 * user can recover from by signing in interactively.
 * https://openid.net/specs/openid-connect-core-1_0.html#AuthError
 * @ignore
 */
export const RECOVERABLE_ERRORS = [
  'login_required',
  'consent_required',
  'interaction_required',
  'account_selection_required',
  // Strictly speaking the user can't recover from `access_denied` - but they
  // can get more information about their access being denied by logging in
  // interactively.
  'access_denied'
];

/**
 * @ignore
 */
export const DEFAULT_SESSION_CHECK_EXPIRY_DAYS = 1;

/**
 * @ignore
 */
export const DEFAULT_AUTH_CLIENT = {
  name: 'identity-web-sdk',
  version: version
};

export const DEFAULT_NOW_PROVIDER = () => Date.now();

/**
 * To Block refresh token server call after subsequent failures
 * @ignore
 */
export const BLOCK_REFRESH_TOKEN_CALL_ATTEMPTS = 3;

export const BLOCKED_REFRESH_TOKEN_CALL_ERROR =
  'Failed to fetch token using Refresh token.Please try again after sometime.';

export const BASE_JITTER = 10;

export const MAX_TIMEOFF = 300;

/*
 *To map the origin based on the environment
 * @ignore
 */
export const IDP_ENV_ORIGIN_MAP: OriginMap = {
  dev: 'https://signin-dev.autodesk.com',
  stg: 'https://signin-stg.autodesk.com',
  prod: 'https://signin.autodesk.com'
};

export const NEW_IDP_ERROR_MESSAGE = 'identity-idp-error';
